import React, { Component, Suspense, lazy } from "react";
import { withRouter } from "react-router-dom";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";
import Modal from "react-modal";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { LoginButton, Loader } from "..";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMobileAlt, faEnvelope } from "@fortawesome/free-solid-svg-icons";

/* Нэвтрэх маягтууд (Firebase-тэй хамт ~120KB) зөвхөн нэвтрэх цонх
   нээгдэхэд татагдана — header бүх хуудсанд байдаг тул эдгээрийг
   шууд импортлох нь хуудас бүрийн ачааллыг хүндрүүлж байсан. */
const EmailAuth = lazy(() => import("../../utils/email-auth"));
const PhoneAuth = lazy(() => import("../../utils/firebase-phoneauth"));

const storeId = process.env.REACT_APP_STOREID;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false,
      errorMessage: "",
      isLoading: false,
      selectedValue: "mobile",
      hideOptions: false,
      buttonClicked: false,
      isAuthModalOpen: false,
      segmentedControlModal: false,
    };

    this.controlRef = React.createRef();

    this.segments = [
      {
        label: <Translate id="button.mobile" />,
        value: "mobile",
        ref: React.createRef(),
      },
      {
        label: <Translate id="button.email" />,
        value: "email",
        ref: React.createRef(),
      },
    ];

    this.handleSegmentedControlValue = this.handleSegmentedControlValue.bind(this);
  }

  handleModalClose = () => {
    this.setState({ segmentedControlModal: false });
  };

  getLoginReturnUrl = () => {
    const saved = sessionStorage.getItem("loginReturnUrl");
    sessionStorage.removeItem("loginReturnUrl");
    // Өгөгдмөл нь /premium (`containers/login.js` -тэй ижил)
    return saved || "/premium";
  };

  handleButtonClicked = () => {
    if (this.state.errorMessage === "") {
      /* Query-г ЗААВАЛ хамт хадгална: /premium?eventId=..&ticketId=..
         дээрээс толгойн "Нэвтрэх" дарсан хэрэглэгч буцаж ирэхдээ
         эвентийн хам сурвалжаа алдвал тасалбарын ваучер олгогдохгүй. */
      const path = `${window.location.pathname}${window.location.search}`;
      if (window.location.pathname.startsWith("/premium")) {
        sessionStorage.setItem("loginReturnUrl", path);
      }
      this.setState({
        buttonClicked: true,
        isAuthModalOpen: true,
        segmentedControlModal: true,
      });
    }
  };

  closeModal = () => {
    this.setState({
      buttonClicked: false,
      isAuthModalOpen: false,
      segmentedControlModal: false,
    });
  };

  handleSegmentedControlValue = (value) => {
    this.setState({ selectedValue: value });
  };

  handleChange = (e) => {
    this.setState({
      selectedValue: e.target.value,
      hideOptions: true,
    });
  };

  async loginResponse(response) {
    this.auth.authData = response.data;
    this.loginUser(this.auth, storeId);
  }

  // Mobile login details

  registerMobileUser = (auth, storeId) => {
    const registerData = {
      PhoneNumber: parseInt(auth.authData.phone.number),
      CountryCode: auth.authData.phone.countryCode,
      Token: auth.authData.code,
    };

    axios
      .post(`${process.env.REACT_APP_SERVICES_API_BASE}/users/registerbymsisdn`, registerData, {
        headers: { StoreId: storeId },
      })
      .then((resp) => {
        console.log(resp.data, resp.status);
        this.loginMobileUser(auth, storeId);
      })
      .catch((err) => {
        this.setState({
          errorMessage: this.props.translate("auth.registration-failed"),
          isLoading: false,
          isLoggedIn: false,
        });
        console.log(err);
      });
  };

  async loginMobileResponse(response) {
    const { status } = response;

    if (status === "PARTIALLY_AUTHENTICATED") {
      this.auth.authData = response.data;
      this.loginMobileUser(this.auth, storeId);
    }
  }

  loginMobileUser = (auth, storeId) => {
    const phone_number = parseInt(auth.authData.phone.number);
    const msisdn = `${auth.authData.phone.countryCode}${phone_number}`;
    const code = auth.authData.code;

    axios
      .get(`${process.env.REACT_APP_SERVICES_API_BASE}/application/grantUrl`, {
        headers: { StoreId: storeId },
      })
      .then((grantResponse) => {
        const grantURL = grantResponse.data.grantURL;
        localStorage.setItem("grantURL", grantURL);

        axios
          .post(
            `${grantURL}`,
            `grant_type=msisdn&msisdn=${msisdn}&skip_decryption=true&code=${code}`,
            {
              headers: {
                StoreId: storeId,
                "Content-Type": "application/x-www-form-urlencoded",
              },
            },
          )
          .then((resp) => {
            const status = resp.status;
            if (status === 200) {
              this.setState({ isLoggedIn: true, isLoading: false });
              const accessToken = resp.data.access_token;
              const data = jwt_decode(accessToken);
              auth.authData.sub = data.sub;

              this.setState({ isLoading: true });

              auth.authData.access_token = accessToken;
              auth.authData.refresh_token = resp.data.refresh_token;
              auth.storeAuth();

              this.props.history.push(this.getLoginReturnUrl());
              window.location.reload();
            }
          })
          .catch((err) => {
            console.log(err);

            if (Object.keys(err).indexOf("response") === -1) {
              console.log(err);

              return;
            }

            const status = err.response.data.error;

            switch (status) {
              // Register the user
              case "604":
                this.registerMobileUser(auth, storeId);
                break;
              // Invalid phone number
              case "603":
                this.setState({
                  errorMessage: this.props.translate("auth.cant-authenticate-mobile"),
                });
                break;
              case "403":
                this.setState({
                  errorMessage: this.props.translate("auth.invalid-code"),
                });
                break;
              default:
                this.setState({
                  errorMessage: this.props.translate("auth.login-failed"),
                });
                console.log(err);
            }
            this.setState({ isLoggedIn: false, isLoading: false });
          });
      });
  };

  // End of mobile login details

  loginUser = (auth, storeId) => {
    const username = encodeURIComponent(auth.authData.username);
    const password = `${auth.authData.password}`;

    axios
      .get(`${process.env.REACT_APP_SERVICES_API_BASE}/application/grantUrl`, {
        headers: { StoreId: storeId },
      })
      .then((grantResponse) => {
        const grantURL = grantResponse.data.grantURL;
        localStorage.setItem("grantURL", grantURL);

        axios
          .post(
            `${grantURL}`,
            `grant_type=password&username=${username}&password=${password}&skip_decryption=true`,
            {
              headers: {
                StoreId: storeId,
                "Content-Type": "application/x-www-form-urlencoded",
              },
            },
          )
          .then((resp) => {
            const status = resp.status;

            if (status === 200) {
              const accessToken = resp.data.access_token;
              const data = jwt_decode(accessToken);
              auth.authData.sub = data.sub;

              this.setState({ isLoading: true }, () => {
                auth.authData.access_token = accessToken;
                auth.authData.refresh_token = resp.data.refresh_token;
                auth.storeAuth();

                this.props.history.push(this.getLoginReturnUrl());
                window.location.reload();
              });
            } else {
              this.setState({
                isLoading: false,
                errorMessage: this.props.translate("auth.failed-login"),
              });
              toast.error(<Translate id="auth.login-failed" />);
            }
          })
          .catch((err) => {
            this.setState({
              isLoading: false,
              errorMessage: this.props.translate("auth.failed-login"),
            });
            toast.error(<Translate id="auth.login-failed" />);
          });
      });
  };

  async registerResponse(response) {
    this.auth.authData = response.data;
    this.registerUser(this.auth, storeId);
  }

  registerUser = (auth, storeId) => {
    const username = `${auth.authData.username}`;
    const password = `${auth.authData.password}`;
    const otp = `${auth.authData.otp}`;
    const country = `${auth.authData.country}`;

    const registerData = {
      Email: username,
      Username: username,
      Password: password,
      Country: country,
      Language: "en",
      Otp: otp,
    };

    axios
      .post(`${process.env.REACT_APP_SERVICES_API_BASE}/users/register`, registerData, {
        headers: { StoreId: storeId },
      })
      .then((resp) => {
        toast.success(<Translate id="auth.account-created-successfully" />);
        this.loginUser(auth, storeId);
      })
      .catch((err) => {
        toast.error(<Translate id="auth.error-creating-account" />);
      });
  };

  render() {
    const modalStyle = {
      content: {
        marginTop: "10vh",
        marginBottom: "auto",
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: "450px",
        maxHeight: "80vh",
        height: "fit-content",
        overflowY: "auto",
        background: "#404040",
        border: "1px solid #555555",
        borderRadius: "12px",
        padding: "30px",
      },
    };

    const { loginModalIsOpen } = this.state;
    const { segmentedControlModal } = this.state;
    const isModalOpen = loginModalIsOpen;

    document.body.classList.toggle("modal-open", isModalOpen);
    document.body.classList.toggle("modal-open", segmentedControlModal);

    this.auth = this.props.auth;
    const { errorMessage, isLoading, selectedValue } = this.state;

    const profileButton =
      this.auth.isAuthenticated() && errorMessage === "" ? (
        // <Link to="/profile" className="nav-btn">
        //   <Translate id="button.profile" />
        // </Link>
        <Translate>
          {({ translate }) => (
            <>
              <LoginButton
                onButtonClicked={() => {
                  console.log("proo");
                  this.props.history.push("/profile");
                }}
                btnText={translate("button.profile")}
                showText={this.props.showText}
              />
            </>
          )}
        </Translate>
      ) : (
        <Translate>
          {({ translate }) => (
            <>
              <LoginButton
                onButtonClicked={this.handleButtonClicked}
                btnText={translate("button.login")}
                showText={this.props.showText}
              />
            </>
          )}
        </Translate>
      );

    const toastContainerStyle = {
      zIndex: 1001,
    };

    return (
      <div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          style={toastContainerStyle}
        />

        <Modal
          isOpen={this.state.loginModalIsOpen}
          onRequestClose={this.handleModalClose}
          contentLabel="Login Modal"
          overlayClassName="modal-overlay"
          style={modalStyle}
        ></Modal>

        <Modal
          isOpen={this.state.segmentedControlModal}
          onRequestClose={this.handleModalClose}
          contentLabel="Segmented Control Modal"
          overlayClassName="modal-overlay"
          style={modalStyle}
        >
          <button className="modal-close-x" onClick={this.handleModalClose}>
            ✕
          </button>
          <div className="email-auth-title">
            <Translate id="auth.login-or-register-your-account" />
          </div>
          <div className="auth-toggle-buttons">
            <button
              className={`auth-toggle-btn ${selectedValue === "mobile" ? "active" : ""}`}
              onClick={() => this.handleSegmentedControlValue("mobile")}
            >
              <span className="toggle-icon">
                <FontAwesomeIcon icon={faMobileAlt} />
              </span>
              <Translate id="button.mobile" />
            </button>
            <button
              className={`auth-toggle-btn ${selectedValue === "email" ? "active" : ""}`}
              onClick={() => this.handleSegmentedControlValue("email")}
            >
              <span className="toggle-icon">
                <FontAwesomeIcon icon={faEnvelope} />
              </span>
              <Translate id="button.email" />
            </button>
          </div>

          <Suspense fallback={<Loader />}>
            {selectedValue === "mobile" && (
              <PhoneAuth
                closeModal={this.closeModal}
                loginMobileResponse={this.loginMobileResponse.bind(this)}
                registerMobileResponse={this.registerResponse.bind(this)}
                isLoading={isLoading}
              />
            )}
            {selectedValue === "email" && (
              <EmailAuth
                closeModal={this.closeModal}
                loginResponse={this.loginResponse.bind(this)}
                registerResponse={this.registerResponse.bind(this)}
                isLoading={isLoading}
              />
            )}
          </Suspense>
        </Modal>

        {profileButton}

        {isLoading && (
          <div className="loader">
            <div className="container">
              <Loader />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const WithLogin = withRouter(Login);
export default withLocalize(WithLogin);
